var React = require('react');

function NotificationsOff (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"fill":"currentColor","d":"M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm0-15.5c2.49 0 4 2.02 4 4.5v.1l2 2V11c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68c-.24.06-.47.15-.69.23l1.64 1.64c.18-.02.36-.05.55-.05zM5.41 3.35L4 4.76l2.81 2.81C6.29 8.57 6 9.74 6 11v5l-2 2v1h14.24l1.74 1.74 1.41-1.41L5.41 3.35zM16 17H8v-6c0-.68.12-1.32.34-1.9L16 16.76V17z","key":0}),React.createElement("path",{"fillRule":"nonzero","d":"M0 0H24V24H0z","key":1})]));
}

NotificationsOff.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = NotificationsOff;

NotificationsOff.default = NotificationsOff;
